import Home from './pages/Home';
import Marketing from './pages/Marketing';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Error from './pages/Error';
import {ToastContainer} from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import {useDispatch, useSelector} from 'react-redux';
import {useEffect, useState} from 'react';
import {notifyError} from './utils/toastError';
import {
  addLotteryBoth,
  addLotteryFriday,
  addLotteryTuesday,
} from './redux/lotteryDaySlice';
import Loader from './components/Loader';
import axios from './utils/axios';

function App () {
  const [loader, setLoader] = useState (false);
  const dispatch = useDispatch ();
  const lotteryDay = useSelector (state => state.lotteryDay);
  const { lotteryContract, tuesdayContract,connect } = useSelector(
    state => state.provider
  );

  useEffect (() => {
    if(connect){
      fetchDay ();
    }
  }, [connect]);

  const fetchDay = async () => {
    setLoader (true);
    const fridayTime = await lotteryContract.functions.lotteryEndTime ();
    const tuesdayTime = await tuesdayContract.functions.lotteryEndTime ();
    const fridayActive = await lotteryContract.functions.isLotteryStarted ();
    const tuesdayActive = await tuesdayContract.functions.isLotteryStarted ();

      console.log("tuesday",tuesdayActive.toString())
      console.log("friday",fridayActive.toString())



    if(fridayActive?.toString()==="true"){
      console.log("fri")
      dispatch (addLotteryFriday ({time:fridayTime.toString()}));
    }
    if(tuesdayActive?.toString()==="true"){
      console.log("tuesday")
      dispatch (addLotteryTuesday ({time:tuesdayTime.toString()}));
    }

    if(fridayActive?.toString()==="true" && tuesdayActive?.toString()==="true"){
      dispatch (addLotteryBoth ());
    }

    setLoader (false);
  };
console.log("lottery Day",lotteryDay);
  // const fetchDay = async () => {
  //   setLoader (true);
  //   const resp = await axios.get ('api/lotteryDay/');
  //   if (resp.data.success) {
  //     const {lotteryDays} = resp.data;
  //     if (lotteryDays[0].day === 'Friday' && lotteryDays[0].status === true) {
  //       dispatch (addLotteryFriday ());
  //     }
  //     if (lotteryDays[1].day === 'Tuesday' && lotteryDays[1].status === true) {
  //       dispatch (addLotteryTuesday ());
  //     }

  //     if (
  //       lotteryDays[0].day === 'Friday' &&
  //       lotteryDays[0].status === true &&
  //       lotteryDays[1].day === 'Tuesday' &&
  //       lotteryDays[1].status === true
  //     ) {
  //       dispatch (addLotteryBoth ());
  //     }
  //   } else {
  //     console.log (resp.data);
  //     notifyError ('Error getting active lottery days');
  //   }
  //   setLoader (false);
  // };

  // console.log("lotteryDay", lotteryDay)
  return (
    <div>
      {loader
        ? <div className="text-lyellow font-bold text-2xl flex items-center justify-center h-[100vh]">
            <Loader />
          </div>
        : <div>
            <Router>
              <Routes>
                <Route element={<Home />} path="/" />
                <Route exact element={<Marketing />} path="/marketing" />
                <Route path="*" element={<Error />} />
              </Routes>
            </Router>
            <ToastContainer />

          </div>}
    </div>
  );
}

export default App;
